// derived from the database
export enum BookkeepingAccountantTaskTemplateName {
    PENDING_CLOSE_CREATION_FAILED = 'pending_close_creation_failed',
}

export const BOOKKEEPING_ACCOUNTANT_TASK_TEMPLATE_NAMES = [
    BookkeepingAccountantTaskTemplateName.PENDING_CLOSE_CREATION_FAILED,
];

export const BOOKKEEPING_ACCOUNTANT_TASK_DISPLAY_NAMES: Record<BookkeepingAccountantTaskTemplateName, string> = {
    [BookkeepingAccountantTaskTemplateName.PENDING_CLOSE_CREATION_FAILED]: 'Pending Close Creation Failed',
};
